import * as React from 'react';
import ReactDOM from 'react-dom';

import WishlistProductsSection from 'components/wishlists/components/WishlistProductsSection';
import { runAfterDomLoad } from 'libs/runAfterDomLoad';

type WishlistProductsData = {
  token?: string;
  device?: 'sp' | 'pc';
  isLoginMember?: boolean;
};

const parseData = (
  data: WishlistProductsData
): { token: string; deviceType: 'sp' | 'pc'; isLoginMember: boolean } | null => {
  if (!data.token) {
    return null;
  }
  return {
    token: data.token,
    deviceType: data.device ?? 'pc',
    isLoginMember: data.isLoginMember ?? false,
  };
};

runAfterDomLoad(() => {
  const mountPoint = document.getElementById('wishlist-products-root');
  if (!mountPoint) {
    return;
  }

  const dataElement = document.getElementById('wishlist-products-data');
  if (!dataElement) {
    return;
  }

  const parsedPayload = parseData(JSON.parse(dataElement.textContent || '{}'));
  if (!parsedPayload) {
    return;
  }

  ReactDOM.render(
    <WishlistProductsSection
      token={parsedPayload.token}
      deviceType={parsedPayload.deviceType}
      isLoginMember={parsedPayload.isLoginMember}
    />,
    mountPoint
  );
});
